import { useState } from "react";
import NewOccurrenceFormDialog from "../dialogs/newOccurrenceFormDialog";
import { Occurrence } from "../../../models/occurrence";
import {
  OccurrenceStepLabelEnum,
  OccurrenceStepEnum,
} from "../../../enums/occurrenceStep";
import { useMediaQuery } from "@mui/material";
import { useIntl } from "react-intl";
import { OccurrenceImport } from "./occurrence-import";

export interface INewOccurrenceButtonProps {
  create: (
    occurrence: Occurrence
  ) => Promise<{ wasCreated: boolean; error?: string }>;
  isValidStep: (requiredFields: string[], occurrence: Occurrence) => boolean;
  persona: "MANAGER" | "TOWER" | "CONSULTANT" | "PARTNERSHIP";
  partners: { id: string; name: string }[];
}

const NewOccurrenceButton = (props: INewOccurrenceButtonProps) => {
  const intl = useIntl();
  const [showDialog, setShowDialog] = useState(false);
  const [showSingleOccurrenceDialog, setShowSingleOccurrenceDialog] = useState(false);
  const isResponsiveView = useMediaQuery("(max-width: 1024px)");

  const [occurrence, setOccurrence] = useState<Occurrence>({
    steps: [
      {
        name: OccurrenceStepLabelEnum.CALL,
        step: OccurrenceStepEnum.CALL,
        dtEnd: null,
        latest: 0,
        observation: "",
        report: "",
        estimatedTime: "0",
      },
    ],
  } as Occurrence);

  return (
    <div className={`flex items-center ${isResponsiveView ? "w-full" : ""}`}>
      <button
        type="button"
        className={`btn bg-primary ${isResponsiveView ? "w-full" : "mt-4"}`}
        onClick={() => {
          setOccurrence({} as Occurrence);
          setShowDialog(true);
        }}
      >
        <span className="rioglyph rioglyph-plus" aria-hidden="true" />
        <span className="padding-left-5">{intl.formatMessage({ id: "intl-msg:kanban.newOccurrenceButton.createTicket" })}</span>
      </button>

      {!isResponsiveView ? (
        <div className="border border-left-only border-width-2 mx-5 h-6 text-center mt-4" />
      ) : null}

      <NewOccurrenceFormDialog
        occurrence={occurrence}
        setOccurrence={setOccurrence}
        showDialog={showSingleOccurrenceDialog}
        onClose={() => setShowSingleOccurrenceDialog(false)}
        partners={props.partners}
        create={props.create}
        isValidStep={props.isValidStep}
        persona={props.persona}
      />

      <OccurrenceImport 
        show={showDialog}
        onClose={() => setShowDialog(false)}
        onCreateSingleOccurrence={() => {
          setShowDialog(false);
          setShowSingleOccurrenceDialog(true);
        }}
      />
    </div>
  );
};

export default NewOccurrenceButton;
